<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <p class="body-1">
          A list of our accepted domains and transfer pricing is available
          <a href="https://www.greengeeks.com/support/article/domain-pricing/" target="_blank">here</a>.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'firts-question',
}
</script>
